module.exports = __webpack_public_path__ + "static/media/didi_playing_baja.a9f9e3b8.png";